import { ReactNode } from 'react'
import { IconWrapper } from 'shared/atoms'
import { WithClassName } from 'shared/types/general.types'
import { cn } from 'utils/style'

type FormSubsectionProps = WithClassName<{
	title: string
	description?: string
	icon: ReactNode
	tone?: 'primary' | 'success' | 'warning' | 'danger'
}>

const tones = {
	primary: { bg: 'bg-primary-soft', text: 'text-primary' },
	success: { bg: 'bg-success-soft', text: 'text-success' },
	warning: { bg: 'bg-warning-soft', text: 'text-warning' },
	danger: { bg: 'bg-danger-soft', text: 'text-danger' }
}

export const FormSubsection = ({
	title,
	description,
	icon,
	tone = 'primary',
	className
}: FormSubsectionProps) => (
	<div
		className={cn(
			'mt-1 flex items-start gap-3 border-t border-border pt-4 sm:col-span-2',
			className
		)}>
		<IconWrapper size="sm" iconBgColor={tones[tone].bg} iconColor={tones[tone].text}>
			{icon}
		</IconWrapper>
		<div className="min-w-0">
			<h3 className="font-display text-sm font-semibold normal-case text-foreground">{title}</h3>
			{description && <p className="text-xs normal-case text-muted-foreground">{description}</p>}
		</div>
	</div>
)
